<template>
  <v-dialog v-model="dialog" :persistent="direcoryChangeLoading"  max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined small v-bind="attrs" v-on="on" class="mx-3">
        {{ $t("text.change_org") }}
      </v-btn>
    </template>
    <v-card>

      <template v-if="!directoryOptionsLoading && !direcoryChangeLoading">
        <v-text-field v-model="searchword" placeholder="Search" prepend-inner-icon="mdi-magnify" outlined class="pa-3" dense hide-details>
        </v-text-field>
        <v-list class="py-0" style="overflow-y: auto; max-height: 350px;">
          <v-list-item v-for="(option, index) in filteredItems" :key="index" link style="border-top: 1px solid #ccc;" 
            @click="changeDirectory(option)">
            <v-list-item-icon class="mr-4">
              <v-icon :color="option.Id == directory.Id ? 'primary' : ''"
                      v-text="option.Id == directory.Id ? ' mdi-check' : ' mdi-domain'">
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="option.Id == directory.Id ? 'primary--text' : ''">{{option.Name}}</v-list-item-title>
              <v-list-item-subtitle :class="option.Id == directory.Id ? 'primary--text text--lighten-1' : ''">{{option.OrganisationNumber}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-else>
        <v-row no-gutters align="center" justify="center" style="height: 200px;">
          <v-progress-circular indeterminate size="100" width="4" color="primary">
          </v-progress-circular>
      </v-row>
      </template>
    </v-card>
  </v-dialog>
</template>


<script>
import client from "@/api/client";

export default {
  name: "DirectorySwitcher",
  props: {},
  components: {},

  data() {
    return {
      searchword: "",
      directoryOptionsLoading: false,
      direcoryChangeLoading: false,
      menuWidth: "100vw",
      dialog: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.getMenuWidth();
    }, 600);
  },

  methods: {
    changeDirectory(e) {
      //console.log(e);
      if (e.Id != this.directory.Id) {
        this.direcoryChangeLoading = true;
        client()
          .post("/api2/Token/impersonate?customerId=" + e.Id)
          .then((response) => {
            //console.log(response);
            this.$store.dispatch("updateToken", response.data);
            var exceptions = [
              "CustomerMachineList",
              "Dashboard",
              "CustomerJobs",
              "Organization",
            ];
            if (!exceptions.includes(this.$route.name)) {
              this.$router.push({ name: "Dashboard" });
            }

            location.reload();
          })
          .catch((e) => {
            this.direcoryChangeLoading = false;
            console.error(e)
          });
      }
    },

    getMenuWidth() {
      var maxwidth = "100vw";
      var ref = this.$refs.directorydropdownbtn;
      if (ref) {
        var left = ref.__vue__.$el.getBoundingClientRect().x;
        var leftWithScrollbarOffset = left + 16;
        maxwidth = "calc(100vw - " + leftWithScrollbarOffset + "px)";
      }
      this.menuWidth = maxwidth;
      //console.log(this.$refs, ref, maxwidth, leftWithScrollbarOffset);
    },
  },

  computed: {
    directory() {
      return this.$store.state.userInfo.Customer;
    },

    filteredItems() {
      if (this.searchword) {
        return this.items.filter((x) =>
          x.Name.toLowerCase().includes(this.searchword.toLowerCase())
        );
      } else {
        return this.items;
      }
    },

    items() {
      //console.log("items", this.$store.state.userInfo.ImpersonationOptions);
      if (this.$store.state.userInfo?.ImpersonationOptions) {
        var list = this.$store.state.userInfo.ImpersonationOptions;
        var current = this.$store.state.userInfo.Customer;
        if (!list.find((x) => x.Id == current.Id)) {
          return [...list, this.$store.state.userInfo.Customer];
        } else {
          return list;
        }
      } else {
        return [this.$store.state.userInfo.Customer];
      }
    },
  },

  watch: {},
};
</script>